import React from 'react';
import PropTypes from 'prop-types';

import ExtLink from './ExtLink';

import Link from '../svg/link.svg';

import styles from './TopicChildren.module.scss';

const TopicChildren = ({data}) => {
  if (!data.length) {
    return null;
  }

  return (
    <section className={styles.container}>
      <div className="wrap">
        <div className={styles.wrap}>
          <h3 className={styles.title}>Atuação legislativa</h3>

          <ul className={styles.list}>
            {data.map(node => {
              return (
                <li>
                  <ExtLink to={node.acf.url}>
                    <div className={styles.projectMeta}>
                      {node.acf.codigo}
                      <Link />
                    </div>
                    <div className={styles.projectTitle} dangerouslySetInnerHTML={{__html: node.title}} />
                    <div className={styles.projectExcerpt} dangerouslySetInnerHTML={{__html: node.excerpt}} />
                  </ExtLink>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

TopicChildren.propTypes = {
  data: PropTypes.array,
};

export default TopicChildren;
